import { Navigate, Route } from 'react-router-dom';
import { SentryRoutes } from '@app/analytics';
import { Login } from './pages/Login/Login';
import { ClientSignup } from './pages/Signup/ClientSignup';

import { NotFound } from '@app/core';

import { Dashboard } from './pages/Dashboard';
import { ForgottenPassword } from './pages/ForgottenPassword';
import { AnonymousQuote, StudySetup } from './pages/StudySetup';
import { TeamMemberSignup } from 'pages/Signup/TeamMemberSignup/TeamMemberSignup';
import { SessionsList } from './pages/Dashboard/Sessions/SessionsList';
import { Welcome } from './pages/Dashboard/Welcome';
import { ParticipantList } from './pages/Dashboard/Panel/ParticipantList';
import { EditSession } from './pages/Dashboard/EditSession';
import { Sessions } from './pages/Dashboard/Sessions';
import { Settings } from './pages/Dashboard/Settings';
import { Billing } from './pages/Dashboard/Billing';
import { SessionDetails } from './pages/Dashboard/Sessions/Details';
import { Preview } from './pages/Dashboard/Sessions/Preview';
import { EditAccount } from './pages/Dashboard/Settings/EditAccount';
import { ChangeForgottenPassword } from './pages/ForgottenPassword/ChangePassword';
import { TeamInformations } from './pages/Dashboard/Settings/TeamInformations';
import { Panels } from './pages/Dashboard/Settings/Panels';
import { UIKit } from './pages/Dashboard/Settings/UIKit';
import { ToolIntegrations } from './pages/Dashboard/Settings/ToolIntegrations';
import { BillingSettings } from './pages/Dashboard/Settings/BillingSettings';
import { PanelSubscriptionForm } from './pages/Anonymous/SubscribePanel/PanelSubscriptionForm';
import { PanelSubscriptionFormSuccess } from './pages/Anonymous/SubscribePanel/PanelSubscriptionFormSuccess';
import { ForgottenPasswordRequest } from './pages/ForgottenPassword/ForgottenPasswordRequest';
import { ForgottenPasswordSuccess } from './pages/ForgottenPassword/ForgottenPasswordSuccess';
import { ChangePasswordSuccess } from './pages/ForgottenPassword/ChangePasswordSuccess';
import { ChangePassword } from './pages/Dashboard/Settings/ChangePassword';
import { RedirectFromDeprecated } from './pages/Anonymous/RedirectFromDeprecated';
import { Evaluation } from './pages/Dashboard/Sessions/Evaluation';
import { Referrals } from './pages/Dashboard/Settings/Referrals';
import { Panel } from './pages/Dashboard/NewPanel/Panel';
import { EmptyPanel } from './pages/Dashboard/NewPanel/EmptyPanel';
import { SpecialOfferPage } from './pages/Dashboard/SpecialOffer/SpecialOfferPage';
import { SpecialOfferDashboardPage } from './pages/Dashboard/SpecialOffer/SpecialOfferDashboardPage';
import { PaymentPage } from './pages/Payment/PaymentPage';
import { InvoicePage } from './pages/Invoice/InvoicePage';
import { AnonymousAppointment } from './pages/Anonymous/Appointment';
import { CreateQuotePage, QuotePage } from './pages/Dashboard/Quote';

export const MainRouter = () => {
  // prettier-ignore
  return (
    <SentryRoutes>
      <Route path="/*" element={<Dashboard/>}>
        <Route index element={<SessionsList/>}/>
        <Route path="welcome" element={<Welcome/>}/>
        <Route path="panel" element={<ParticipantList/>}/>
        <Route path="new-panel" element={<EmptyPanel />}/>
        <Route path="new-panel/:id" element={<Panel />}/>
        <Route path="sessions/*" element={<Sessions/>}>
          <Route path="*" element={<Navigate to="/" replace/>}/>
          <Route path="edit/:id/*" element={<EditSession/>}/>
          <Route path="create" element={<StudySetup/>}/>
          <Route path="details/:id/*" element={<SessionDetails/>}/>
          <Route path="preview/:id" element={<Preview/>}/>
          <Route path=":id/evaluation" element={<Evaluation/>}/>
        </Route>
        <Route path="settings/*" element={<Settings/>}>
          <Route index element={<Navigate to={`account`} replace/>}/>
          <Route path="account" element={<EditAccount/>}/>
          <Route path="change-password" element={<ChangePassword/>}/>
          <Route path="team" element={<TeamInformations/>}/>
          <Route path="referrals" element={<Referrals/>}/>
          <Route path="billing" element={<BillingSettings/>}/>
          <Route path="panels" element={<Panels/>}/>
          <Route path="ui-kit" element={<UIKit/>}/>
          <Route path="tool-integrations" element={<ToolIntegrations/>}/>
          <Route path="*" element={<NotFound/>}/>
        </Route>
        <Route path="billing-dashboard/*" element={<Billing/>}/>
        <Route path="special-offer" element={<SpecialOfferDashboardPage />}/>
        <Route path="quote" element={<QuotePage/>}/>
        <Route path="quote/new" element={<CreateQuotePage/>}/>
        <Route path="quote/:idOrRef" element={<QuotePage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Route>

      <Route path="/special-offer-annon" element={<SpecialOfferPage  />}/>
      <Route path="/special-offer-anon" element={<Navigate to="/special-offer-annon" replace  />}/>
      <Route path="/payment" element={<PaymentPage/>}/>
      <Route path="/invoice/:id" element={<InvoicePage/>}/>

      <Route path="/recruit-participants" element={<AnonymousQuote/>} />
      <Route path="/recruter-des-participants" element={<AnonymousQuote/>} />

      <Route path="/login" element={<Login/>}/>
      <Route path="/signup" element={<ClientSignup/>}/>
      <Route path="/trouver-des-participants" element={<Navigate to="/signup" replace/>}/>

      <Route path="/invitation/:id" element={<TeamMemberSignup/>}/>

      <Route path="/study/:id/*" element={<RedirectFromDeprecated/>}/>
      <Route path="/s/:id/*" element={<RedirectFromDeprecated/>}/>
      <Route path="/p/:id/*" element={<RedirectFromDeprecated/>}/>

      <Route path="/anonymous/*">
        <Route path="participation/:id/*" element={<RedirectFromDeprecated/>}/>
        <Route path="subscribe-panel/:id" element={<PanelSubscriptionForm/>}/>
        <Route path="subscribe-panel/:id/success" element={<PanelSubscriptionFormSuccess/>}/>
        <Route path="appointment/:id" element={<AnonymousAppointment />} />

        <Route path="*" element={<NotFound/>}/>
      </Route>

      <Route path="/forgotten-password/*" element={<ForgottenPassword/>}>
        <Route path="request" element={<ForgottenPasswordRequest/>}/>
        <Route path="success" element={<ForgottenPasswordSuccess/>}/>
        <Route path="change-password" element={<ChangeForgottenPassword/>}/>
        <Route path="change-success" element={<ChangePasswordSuccess/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Route>

      <Route path="/anonymous/panel/505d8401-d04c-4b15-91ca-4b009f4c8ad7/register" Component={() => {
        window.location.href = "https://participant.tandemz.io/profile";
        return null;
      }} />
    </SentryRoutes>
  );
};
